<template>
    <div>
        <el-divider class="title" content-position="left">婚庆信息</el-divider>
        <el-row :gutter="20">
            <el-col :span="12">新郎姓名：{{wedinfo.maleName}}</el-col>
            <el-col :span="12">新娘姓名：{{wedinfo.femaleName}}</el-col>
            <el-col :span="12">手机号码：{{wedinfo.phoneMale}}</el-col>
            <el-col :span="12">其他手机号码：{{wedinfo.phoneFemale}}</el-col>
            <el-col :span="12">典礼开始时间：{{wedinfo.orderDate}} {{wedinfo.beginTime}}</el-col>
            <el-col :span="12">下单日期：{{wedinfo.createTime}}</el-col>
            <el-col>套餐名称：{{wedinfo.weddingPackageName||'无'}}</el-col>
            <el-col>{{wedinfo.packageContent?('('+wedinfo.packageContent+')'):''}}</el-col>
            <el-col>婚庆价格：{{wedinfo.orderMoney||0}}元</el-col>
            <el-col>增加项目：{{wedinfo.exItemMoney||0}}元</el-col>
            <el-col>{{wedinfo.orderExtraContent?('('+wedinfo.orderExtraContent+')'):''}}</el-col>
            <el-col>婚庆订金：{{wedinfo.downPayment||0}}元</el-col>
            <el-col>预计应收：{{wedinfo.orderWeddingMoney||0}}元</el-col>
            <el-col>已收金额：{{wedinfo.realPayment||0}}元</el-col>
            <el-col>接待人员：{{wedinfo.createUserName||'无'}}</el-col>
            <el-col>接待电话：{{wedinfo.createUserPhone||'无'}}</el-col>
            <el-col><span class="ls-28 ">备</span>注：{{wedinfo.remark||'无'}}</el-col>
        </el-row>
    </div>
</template>

<script>
    export default {
        name: "weddingbase",
        props:{
            info:Object,
        },
        data(){
            return{
                wedinfo:{}
            }
        },
        watch:{
            info(newval,oldval){
                console.log(newval)
                if(newval!=oldval){
                    var info=this.info;
                    var packageContent='',orderExtraContent='';
                    for(var i in info.weddingItemsExs){
                        packageContent +=info.weddingItemsExs[i].itemName+'、';
                    }
                    if(packageContent.substring(packageContent.length-1,packageContent.length)=='、'){
                        info.packageContent=packageContent.substring(0,packageContent.length-1)
                    }

                    for(var i in info.extra){
                        orderExtraContent +=info.extra[i].itemName+':'+info.extra[i].itemPrice+'*'+info.extra[i].itemCount+'、';
                    }
                    if(orderExtraContent.substring(orderExtraContent.length-1,orderExtraContent.length)=='、'){
                        info.orderExtraContent=orderExtraContent.substring(0,orderExtraContent.length-1)
                    }
                    this.wedinfo=info;
                }
            }
        },
        mounted(){
            this.wedinfo=this.info;
        }
    }
</script>

<style scoped lang="scss">
    .el-divider__text {
        font-weight: 700 !important;
        color: #5295e7;
    }
</style>